import React, { useEffect, useRef } from "react";
import { useIds } from "../../../../hook/AdminContext";
import { FacebookIcon } from "../../../../assets/icon/FacebookIcon";
import InstagramIcon from "../../../../assets/icon/InstagramIcon";
import TiktokIcon from "../../../../assets/icon/TiktokIcon";
import LinkedinIcon from "../../../../assets/icon/LinkedinIcon";
import YoutubeIcon from "../../../../assets/icon/YoutubeIcon";
import { Divider } from "@mui/material";
import { TwitterIcon } from "../../../../assets/icon/TwitterIcon";
import JobSwiper from "../../../../components/CustomSwiper/JobSwiper";
import AchievementListing from "../Media/MediaListing";
import PostSwiper from "../../../../components/CustomSwiper/PostSwiper";

function HomeForCoachAndLeader({
  data,
  isCoachModal,
  isCompanyProfile,
  companyType,
  setJobListing,
  fetchDetails,
  handleMoveJobCandidates,
  handleMoveJobDetails,
  handleMoveToMedia,
  handleMoveToJobs,
  handleMoveToPosts,
}) {
  const [customWidth, setCustomWidth] = React.useState(0);
  const { userInfo, handleEmailClick } = useIds();

  console.log(data, "--data");

  const InfoRow = ({ label, value }) => (
    <>
      <div className="info-row">
        <label className="label-style">{label}</label>
        <span className="info-value">{value || "N/A"}</span>
      </div>
      <Divider />
    </>
  );

  const MultipleChipRow = ({ label, value, name }) => (
    <>
      <div className="info-row">
        <label className="label-style me-2">{label}</label>
        <div className="d-flex tw-gap-1">
          {value.map((obj) => (
            <>
              <span className="chip-input">
                {obj[`${name}`] || "N/A"}
              </span>
            </>
          ))}
        </div>
      </div>
      <Divider />
    </>
  );

  useEffect(() => {
    document.getElementsByClassName("client-info")[0]?.offsetWidth &&
      setCustomWidth(
        document.getElementsByClassName("client-info")[0]?.offsetWidth - 30
      );
  }, []);
  return (
    <>
      {/* ABOUT / DESCRIPTION */}

      <div className="client-info shadow-md  improved-card w-100">
        <div className="row g-4">
          <div className="col-md-12">
            <div className="info-section detail-page-text">
              {/* Contact Name / Company Name */}
              <InfoRow
                label={isCoachModal ? "Company Name" : "Contact Name"}
                value={
                  isCoachModal
                    ? data.company_name
                    : data?.contact_name || data?.name
                }
              />

              {/* Sector(s) */}
              {data?.client_type?.length > 0 ? (
                data.client_type
                  .filter((obj) => obj.sector?.title)
                  .map((clientType, i) => (
                    <InfoRow
                      key={i}
                      label={`Sector (${clientType?.title})`}
                      value={clientType?.sector?.title}
                    />
                  ))
              ) : (
                <InfoRow label="Sector" value="N/A" />
              )}

              {/* Website */}
              <InfoRow
                label="Website"
                value={
                  data?.website_url ? (
                    <a
                      className="info-value-link"
                      href={data.website_url}
                      target="_blank"
                    >
                      {data.website_url}
                    </a>
                  ) : (
                    <span className="text-muted">No data</span>
                  )
                }
              />

              <InfoRow
                label="Contact Number"
                value={data?.contact_number || "N/A"}
              />

              <InfoRow
                label="Email"
                value={
                  data?.email ? (
                    <span
                      className="info-value-link"
                      onClick={() => handleEmailClick(data.email)}
                    >
                      {data?.email}
                    </span>
                  ) : (
                    "N/A"
                  )
                }
              />

              {/* Conditional "Type" */}
              {(isCompanyProfile ||
                (isCoachModal && companyType == "coach")) && (
                  <>
                    {Array.isArray(data?.[companyType]?.profile_type) ||
                      Array.isArray(data?.profile_type) ? (
                      <MultipleChipRow
                        label="Type"
                        value={
                          data?.[companyType]?.profile_type || data?.profile_type
                        }
                        name="name"
                      />
                    ) : (
                      <InfoRow
                        label="Type"
                        value={
                          data?.[companyType]?.profile_type?.name ||
                          data?.profile_type?.name ||
                          "N/A"
                        }
                      />
                    )}
                  </>
                )}
            </div>

            {/* SOCIAL LINKS */}
            <div className="social-links-container">
              {data?.social_links?.facebook && (
                <a href={data.social_links.facebook} target="_blank">
                  <FacebookIcon />
                </a>
              )}
              {data?.social_links?.instagram && (
                <a href={data.social_links.instagram} target="_blank">
                  <InstagramIcon />
                </a>
              )}
              {data?.social_links?.tiktok_link && (
                <a href={data.social_links.tiktok_link} target="_blank">
                  <TiktokIcon />
                </a>
              )}
              {data?.social_links?.linkedin && (
                <a href={data.social_links.linkedin} target="_blank">
                  <LinkedinIcon />
                </a>
              )}
              {data?.social_links?.twitter && (
                <a href={data.social_links.twitter} target="_blank">
                  <TwitterIcon />
                </a>
              )}
              {data?.social_links?.youtube && (
                <a href={data.social_links.youtube} target="_blank">
                  <YoutubeIcon />
                </a>
              )}
            </div>

            {/* DIRECT CONTACT */}
            {userInfo.role == "client" &&
              data?.role == "client" &&
              data?.direct_contact_enabled &&
              data?.direct_contact?.full_name && (
                <div className="card direct-contact-card p-4 mt-4">
                  <h6 className="fw-bold mb-3">Direct Contact Information</h6>

                  <InfoRow
                    label="Full Name"
                    value={data.direct_contact.full_name}
                  />
                  <InfoRow
                    label="Job Title"
                    value={data.direct_contact.job_title || "N/A"}
                  />
                  <InfoRow
                    label="Email Address"
                    value={
                      data.direct_contact.email_address ? (
                        <span
                          className="info-value-link"
                          onClick={() =>
                            handleEmailClick(data.direct_contact.email_address)
                          }
                        >
                          {data.direct_contact.email_address}
                        </span>
                      ) : (
                        "N/A"
                      )
                    }
                  />
                  {/* <InfoRow
                    label="Company Email Address"
                    value={
                      data.direct_contact.email_address ? (
                        <span
                          className="info-value-link"
                          onClick={() =>
                            handleEmailClick(data.direct_contact.company_email)
                          }
                        >
                          {data.direct_contact.company_email}
                        </span>
                      ) : (
                        "N/A"
                      )
                    }
                  /> */}
                  <InfoRow
                    label="Phone Number"
                    value={data.direct_contact.phone_number || "N/A"}
                  />
                </div>
              )}
          </div>
        </div>
      </div>



      {/* {data.feeds?.length > 0 && (
        <div className="card shadow-md p-4 pb-0 mt-2 mb-2 about-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-bold mb-2">Posts</h6>
            <button
              className="btn-outlined-sm tw-group"
              onClick={() => {
                handleMoveToPosts();
              }}
            >
              View All
            </button>
          </div>
          {customWidth && (
            <div style={{ width: customWidth }}>
              <PostSwiper data={data.feeds}></PostSwiper>
            </div>
          )}
        </div>
      )} */}

      {/* {data.jobs?.length > 0 && (
        <div className="card shadow-md p-4 pb-0 mt-2 mb-2 about-content">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="fw-bold mb-2">Jobs</h6>
            <button
              className="btn-outlined-sm tw-group"
              onClick={() => {
                handleMoveToJobs();
              }}
            >
              View All
            </button>
          </div>
          {customWidth && (
            <div style={{ width: customWidth }}>
              <JobSwiper
                data={data.jobs}
                setJobListing={setJobListing}
                fetchDetails={fetchDetails}
                handleMoveJobCandidates={handleMoveJobCandidates}
                handleMoveJobDetails={handleMoveJobDetails}
              ></JobSwiper>
            </div>
          )}
        </div>
      )} */}
      {/* {data.achievements?.length > 0 && (
        <div className="card shadow-md p-4 pt-3 pb-0 mt-2 mb-2 about-content">
          {customWidth && (
            <div style={{ width: customWidth }}>
              <AchievementListing
                viewType="slider"
                mediaType="achievement"
                media={data.achievements}
                handleUploadComplete={fetchDetails}
                handleViewAllClick={handleMoveToMedia}
                profile_user_id={data._id}
              />
            </div>
          )}
        </div>
      )} */}

      {/* {data.media?.length > 0 && (
        <div className="card shadow-md p-4 pt-3 pb-0 mt-2 mb-2 about-content">
          {customWidth && (
            <div style={{ width: customWidth }}>
              <AchievementListing
                viewType="slider"
                mediaType="media"
                media={data.media}
                handleUploadComplete={fetchDetails}
                handleViewAllClick={handleMoveToMedia}
                profile_user_id={data._id}
              />
            </div>
          )}
        </div>
      )} */}
    </>
  );
}

export default HomeForCoachAndLeader;
